<div class="p-6">
  <app-table
    [config]="chargeInformationBusinesstransactionsTableConfig"
    [data]="tableData"
    [(selectedElements)]="selectedElements"></app-table>
</div>
